 <template>
   <ct-modal
    v-if="visible"
    width="560px"
    append-to-body
    title=""
    class="note-modal"
    @closed="closedModal"
  >
    <div slot="body" class="note-body">
        <div class="img-title">
          <img width="79" src="@/assets/img/comet/question/cuo@2x.png" alt="">
        </div>
        <h4 class="title">You have successfully added this question into mistake book!</h4>
        <div class="input-container">
            <textarea
              :maxlength="maxlength"
              v-model="value"
              v-focus
              class="edit-input"
              placeholder="Writing down the reason why you made the mistake on this question will help you a lot when you review it."
              rows="12">
            </textarea>
        </div>
        <div class="input-count-tip">
          <span class="input-count-tip--count">{{count}}</span>
          <span>/{{maxlength}}</span>
        </div>
    </div>
    <div slot="footer" class="text-center">
          <ct-button
          type="secondary"
          class="action-btn"
          @click.prevent="closedModal"
          >Skip</ct-button>
          <ct-button
          class="action-btn"
          type="primary"
          :disabled="count<=0||count>maxlength"
          :isLoading="loading"
          @click.prevent="submitWrongNote"
          >Save</ct-button>
    </div>
  </ct-modal>
</template>
<script>
import api from '@ca/api'

export default {
  name: 'EditWrongBook',
  props: {
    id: Number,
    note: String,
    closeCallback: Function
  },
  data () {
    return {
      visible: true,
      pending: false,
      value: this.note || '',
      maxlength: 500
    }
  },
  watch: {
    value (value) {
      if (value && value.length && value.length > this.maxlength) {
        this.value = this.value.slice(0, this.maxlength)
      }
    }
  },
  computed: {
    count () {
      const note = this.value.toString()
      return note.length
    },
    loading () {
      return this.pending
    }
  },
  methods: {
    shownoteModal () {
      this.visible = true
    },
    submitWrongNote () {
      this.pending = true
      api.addWrongNote({
        data: {
          question_id: this.id,
          note: this.value
        }
      }).then(res => {
        this.pending = false
        if (res.data && res.data.code === 1) {
          this.closedModal()
          this.$toast({ message: 'Your note has been saved!', type: 'success', duration: 2000 })
        } else {
          this.$toast({ message: res.data.error, type: 'warning', duration: 2000 })
        }
      }, () => {
        this.pending = false
      })
    },
    closedModal () {
      this.visible = false
      this.closeCallback()
    }
  },
  mounted () {
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/_varaible.scss';

$textColor: #A3B1BF;
.note-modal {
  z-index: 2000;
  .img-title{
    text-align: center;
    margin-bottom: 24px;
  }
  .title{
    margin-bottom: 24px;
    text-align: center;
  }
  .action-btn{
    margin: 8px 16px 0;
  }
}
// .input{
//   &-container{
//     font-size:14px;
//     line-height:22px;
//     font-family:SFProDisplay-Regular;
//   }
//   &-count-tip {
//     text-align: right;
//     color: $textColor;
//     &--count{
//       color: $secondary;
//     }
//   }
//   &-hint{
//     line-height:22px;
//     color: $textColor;
//     text-align: left;
//   }
// }
.edit-input{
  background-color: #fff;
  border-radius:2px;
  font-weight:400;
  color:$secondary;
  width: 100%;
  outline: none;
  resize: none;
  padding: 12px;
  font-size: inherit;
  border:1px solid rgba(218,224,229,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
</style>
